module.exports = __webpack_public_path__ + "assets/img/b0ab-uy.svg";